import { action, atom } from '@reatom/framework'
import BigNumber from 'bignumber.js'

import { WalletAddress } from '@root/entities/wallet'
import { walletsByAddressAtom } from '@root/entities/wallet/atoms'

import type { Atom } from '@reatom/framework'
import type { CurrencyModel } from '@root/entities/currency'

export const transferDestinationReatom = ({
  currencyAtom,
}: {
  currencyAtom: Atom<CurrencyModel>
}) => {
  const addressAtom = atom('', 'addressAtom')

  const setAddressAction = action((ctx, address: WalletAddress) => {
    addressAtom(ctx, address)
  }, 'setAddressAction')

  const destinationWalletAtom = atom((ctx) => {
    const address = ctx.spy(addressAtom)
    if (!address) {
      return undefined
    }
    const walletsByAddress = ctx.spy(walletsByAddressAtom)
    const foundWallet = walletsByAddress.get(WalletAddress(address))
    return foundWallet
  }, 'destinationWalletAtom')

  const destinationWalletAsset = atom((ctx) => {
    const currency = ctx.spy(currencyAtom)
    const destinationWallet = ctx.spy(destinationWalletAtom)
    if (!destinationWallet) {
      return undefined
    }
    const assets = ctx.spy(destinationWallet.assetsByCurrency)
    return assets[currency.address]
  }, 'destinationWalletAsset')

  const destinationWalletAssetBalance = atom((ctx) => {
    const assetAtom = ctx.spy(destinationWalletAsset)
    if (!assetAtom) {
      return BigNumber(0)
    }
    return ctx.spy(assetAtom.balance)
  }, 'destinationWalletAssetBalance')

  const destinationWalletAssetBalanceUsd = atom((ctx) => {
    const assetAtom = ctx.spy(destinationWalletAsset)
    if (!assetAtom) {
      return BigNumber(0)
    }
    return ctx.spy(assetAtom.balanceUsd)
  }, 'destinationWalletAssetBalanceUsd')

  return {
    addressAtom,
    setAddressAction,
    destinationWalletAtom,
    destinationWalletAsset,
    destinationWalletAssetBalance,
    destinationWalletAssetBalanceUsd,
  }
}
export type TransferDestinationReatom = ReturnType<
  typeof transferDestinationReatom
>
